(function () {
  /**
   * @deprecated Please use lodash/* directly when required
   */
  // eslint-disable-next-line angular/window-service
  angular.module('binky.core.lodash').constant('_', window._);
})();
